import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { IoClose } from "react-icons/io5";
import whatsappIcon from "../assets/images/whatsapp.svg";
import { WHATSAPP_CHAT_URL } from "./WhatsAppPurchaseBanner";

const HomeWhatsAppPurchaseModal = () => {
  const [showModal, setShowModal] = useState(true);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleWhatsAppClick = () => {
    setShowModal(false);
    window.open(WHATSAPP_CHAT_URL, "_blank", "noreferrer");
  };

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      centered
      className="home-whatsapp-modal"
      backdropClassName="home-whatsapp-modal__backdrop"
      aria-labelledby="home-whatsapp-modal-title"
    >
      <Modal.Body className="home-whatsapp-modal__body">
        <button
          type="button"
          className="home-whatsapp-modal__close"
          onClick={handleClose}
          aria-label="Close WhatsApp purchase modal"
        >
          <IoClose aria-hidden="true" />
        </button>
        {/* <span className="home-whatsapp-modal__badge">WhatsApp checkout</span> */}
        <div className="home-whatsapp-modal__icon-wrap">
          <img
            className="home-whatsapp-modal__icon"
            src={whatsappIcon}
            alt=""
            aria-hidden="true"
          />
        </div>
        <h2 id="home-whatsapp-modal-title" className="home-whatsapp-modal__title">
          Purchase eSIM by WhatsApp
        </h2>
        <p className="home-whatsapp-modal__text">
          Chat with our team and complete your travel eSIM purchase quickly.
        </p>
        <div className="home-whatsapp-modal__points" aria-label="WhatsApp purchase benefits">
          <span>Fast setup</span>
          <span>Secure checkout</span>
          <span>Live support</span>
        </div>
        <button
          type="button"
          className="home-whatsapp-modal__button"
          onClick={handleWhatsAppClick}
        >
          <img src={whatsappIcon} alt="" aria-hidden="true" />
          Continue on WhatsApp
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default HomeWhatsAppPurchaseModal;
